import PriceFormatter from './PriceFormatter';

export default {
  name: 'Cart',

  mixins: [PriceFormatter],

  props: {
    template: { type: String, default: 'full' }
  },

  computed: {
    isFullTemplate() {
      return this.template === 'full';
    },

    isTopMenuTemplate() {
      return this.template === 'top-menu';
    },

    isEmpty() {
      return this.count === 0;
    },

    count() {
      return this.products.length;
    },

    products() {
      return this.$store.getters.cartProducts;
    },

    subTotal() {
      return this.$store.getters.totals.before_discount;
    },

    discount() {
      return this.$store.getters.totals.discount;
    },

    total() {
      return this.$store.getters.totals.final;
    }
  },

  created() {
    this.$store.dispatch('getAllProducts');
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch('getCart');
    });
  },

  methods: {
    removeFromCart(product) {
      this.$store.dispatch('removeFromCart', product);
    },

    emptyCart() {
      this.$store.dispatch('emptyCart');
    },

    addToCart(object) {
      this.$store.dispatch('addToCart', object);
    },

    truncate(string, length = 40) {
      if (!string) {
        return '';
      }

      return _.truncate(string.replace(/<(?:.|\n)*?>/gm, ''), {
        length,
        omission: '...'
      });
    }
  }
};
